//this will be moved as React components for a later project
function pickWinners(experience) {
  return new Promise((resolve) => {
    _createGlobalCampaign(experience);
    Ext.create('NGXConsole.component.window.FullScreenWizardContainer', {
      cards:       NGXConsole.WizardConstants.getCardConfig('PICK_WINNERS'),
      allowCrumbs: false,
      wizardData:  {},
      listeners:   {
        'wizard:save': function () {
          resolve();
        },
      },
    }).show();
  });
}

function downloadWinnersExport(experience) {
  return new Promise((resolve) => {
    _createGlobalCampaign(experience);
    _createConfigObj();
    App.NGXConsole.getController('campaign.Winners').onExportDownloadClick();
    resolve();
  });
}

function sendWinnersExport(experience) {
  return new Promise((resolve) => {
    _createGlobalCampaign(experience);
    _createConfigObj();
    App.NGXConsole.getController('campaign.Winners').onExportSendClick();
    resolve();
  });
}

function _createGlobalCampaign(experience) {
  App.Campaign = Object.assign({}, App.Campaign, {
    id:       experience.id,
    typeRef:  experience.typeRef.id,
    features: {
      hasUGC: experience.hasUGC,
    },
    interactionStrategy: experience.interactionStrategy.id,
  });
}

function _createConfigObj() {
  window.configObj = Object.assign({}, window.configObj, {
    winnerExportAllowed: true, // can't get here if this is false so hardcoding it rather than deriving it
  });
}

export default {
  pickWinners,
  downloadWinnersExport,
  sendWinnersExport,
};
